module.exports = __webpack_public_path__ + "static/media/CY.93a319a0.svg";